<!-- Wnetrze kafelka jest wspolne dla obu wariantow kotwicy (zewnetrzny href vs
     wewnetrzny routerLink) — trzymane raz w <ng-template>, zeby nie dublowac
     markupu i nie rozjechac stylow. -->
<ng-template #tileContent>
  @if (showImage) {
    <img [src]="'./assets/' + buttonImageSrc" [alt]="imageAlt | translate" />
  }
  @if (navName) {
    <p style="text-align: center" [innerHTML]="navName | translate">
    </p>
  }
</ng-template>

@if (externalHref) {
  <!-- Cel zewnetrzny: czysty <a href> — bez dyrektywy routerLink, ktora
       nadpisywalaby attr.href wartoscia null. rel="noopener" defensywnie. -->
  <a class="selection" [href]="externalHref" rel="noopener">
    <ng-container [ngTemplateOutlet]="tileContent"></ng-container>
  </a>
} @else {
  <a
    class="selection"
    [routerLink]="routerLink ? routerLink : null"
    routerLinkActive="router-link-active"
    >
    <ng-container [ngTemplateOutlet]="tileContent"></ng-container>
  </a>
}
